<template>
	<div class="contact-w3-agileits w3ls-section" id="contact">
		<div class="container">
			<h3 class="agileits-title cont-w3l">Contact Me</h3>
			<div class="col-md-10 col-md-offset-1 agileits-main-right">
				<form id="contact-form" @submit.prevent="submitContactForm">
					<div class="row uniform">
						<div class="6u 12u(xsmall)"><input type="text" name="name" v-model="name" required="true" id="name" placeholder="Name*" /></div>
						<div class="6u 12u(xsmall)"><input type="email" name="email" v-model="email" required="true" id="email" placeholder="Email*" /></div>
          </div>
					<div class="row uniform">
						<div class="12u"><input type="text" name="subject" v-model="subject" required="true" id="subject" placeholder="Subject*" /></div>           
					</div>
					<div class="row uniform">
						<div class="12u"><textarea name="message" v-model="message" required="true" id="message" placeholder="Message*" rows="6"></textarea></div>
          </div>
          <span class="formRequired">* Required</span>
          <div class="row uniform">
              <div class="12u"><div class="g-recaptcha" :data-sitekey="siteKey"></div></div>
          </div>
					<div class="row uniform">
						<div class="3u">
							<ul class="actions">
								<input
                  type="submit"
                  value="Send Message"
                  class="special" />
							</ul>
						</div>
            <div class="3u">
							<ul class="actions">
                <input type="reset" id="primary-reset" class="special" value="Reset">
							</ul>
						</div>
					</div>
          <div class="row uniform">
            <div class="12u">
              {{ error }}
            </div>
          </div>
				</form>
			</div>
			<div class="clearfix"></div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Contact',
  data: function () {
    return {
      name: '',
      email: '',
      subject: '',
      message: '',
      error: '',
      siteKey: '6LeVvP8UAAAAAFGXZNyiagTE1LDlIvuZP0Kb8zDZ'
    }
  },
  methods: {
    submitContactForm () {
      if (!this.validateEmail(this.email) || !this.validateEmptyForm(this.name, this.subject, this.message)) {
        return this.error = 'Invalid form. Please submit a valid form'
      }
      const gResponse = document.getElementById('g-recaptcha-response').value

      console.log('before api call')
      const requestBody = {
        name: this.name,
        email: this.email,
        subject: this.subject,
        message: this.message,
        gResponse
      }

      axios.post('/sendContactMessage', requestBody)
      .then(() => {
        console.log('success')
      })
      .catch((error) => {
        console.log(error)
      })
      console.log('after api call')
      document.getElementById('primary-reset').click()
      this.error = 'Form is under maintenance. Sorry for the inconvenience.'
    },
    validateEmail (email) {
      const validation = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return validation.test(email)
    },
    validateEmptyForm (name, subject, message) {
      if (name || subject || message) {
        return true
      }

      return false
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
